import { render, staticRenderFns } from "./AppDialogDetails.vue?vue&type=template&id=197ec33c&"
import script from "./AppDialogDetails.vue?vue&type=script&lang=js&"
export * from "./AppDialogDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports